import styles from "./button-toggle.module.css";

interface ButtonToggleProps {
    value: boolean;
    onToggle: (next: boolean) => void;
    toggleOnLabel: string;
    toggleOffLabel: string;
    disabled?: boolean;
    className?: string;
}

export default function ButtonToggle({
    value,
    onToggle,
    toggleOnLabel,
    toggleOffLabel,
    disabled = false,
    className,
}: ButtonToggleProps): JSX.Element {
    const toggle = () => {
        if (disabled) return;
        onToggle(!value);
    };

    return (
        <button
            type="button"
            role="switch"
            className={[
                styles.buttonToggle,
                value ? styles.on : styles.off,
                disabled ? styles.disabled : "",
                className ?? "",
            ].join(" ")}
            aria-checked={value}
            disabled={disabled}
            onClick={toggle}
        >
            <div className={styles.buttonToggleThumb} />
            <div>{value ? toggleOnLabel : toggleOffLabel}</div>
        </button>
    );
}
